import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock, FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import { AuthContext } from "../components/AuthContext";
import { API_URL } from "../constant";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { setAuthToken } = useContext(AuthContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    // Check if both fields are filled
    if (!email || !password) {
      setErrorMessage("");
      return;
    }

    setIsLoading(true);

    try {
      // Make a POST request to the backend
      const response = await fetch(`${API_URL}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        setErrorMessage("");
        const token = data.token;
        setAuthToken(token);
        localStorage.setItem("authToken", token);
        console.log("Login successful", data);
        navigate("/dashboard");
      } else {
        setErrorMessage(data.message || "Invalid Email or Password");
      }
    } catch (error) {
      console.error("Error during login:", error);
      setErrorMessage("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 font-poppins p-4">
      <form
        onSubmit={handleLogin}
        className="bg-white p-6 rounded-lg shadow-md w-full max-w-md sm:p-8"
      >
        {/* User Icon */}
        <div className="flex justify-center items-center mb-6">
          <div className="flex justify-center items-center w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-gray-100">
            <FaUser className="text-5xl sm:text-7xl text-gray-600" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center text-xl sm:text-2xl font-bold text-gray-700 mb-6">
          Login
        </h2>

        {/* Email */}
        <div className="mb-5">
          <label
            htmlFor="email"
            className="flex items-center font-medium text-sm text-gray-700 mb-2"
          >
            <FaEnvelope className="mr-2" />
            Email
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 sm:py-3 text-sm rounded-lg border border-gray-300 outline-none"
          />
          {isSubmitted && !email && (
            <span className="text-red-500 text-sm mt-1">Email is required</span>
          )}
        </div>

        {/* Password */}
        <div className="mb-5">
          <label
            htmlFor="password"
            className="flex items-center font-medium text-sm text-gray-700 mb-2"
          >
            <FaLock className="mr-2" />
            Password
          </label>
          <div className="flex items-center border border-gray-300 rounded-lg">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="flex-grow px-4 py-3 text-sm rounded-l-lg outline-none"
            />
            <div
              className="pr-3 cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <FaEyeSlash className="text-gray-700" />
              ) : (
                <FaEye className="text-gray-700" />
              )}
            </div>
          </div>
          {isSubmitted && !password && (
            <span className="text-red-500 text-sm mt-1">Password is required</span>
          )}
        </div>

        {/* Error Message */}
        {errorMessage && (
          <span className="text-red-500 text-sm mb-4 block">{errorMessage}</span>
        )}

        {/* Login Button with increased margin */}
        <div className="mt-8">
          <button
            type="submit"
            className="w-full px-4 py-2 sm:py-3 text-sm sm:text-base font-semibold text-white bg-gray-600 rounded-lg hover:bg-gray-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="flex justify-center items-center">
                <svg
                  className="animate-spin h-5 w-5 mr-3 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                  ></circle>
                  <path fill="currentColor" d="M4 12a8 8 0 0 1 16 0"></path>
                </svg>
                Logging in...
              </span>
            ) : (
              "Login"
            )}
          </button>
        </div>
      </form>
    </div>
  );
}

export default Login;
